import anime from 'animejs';

const curtainOpenerTimeline = anime.timeline({
	autoplay: false,
	complete: function(){
		// fade();
	}
});


curtainOpenerTimeline
	.add({
		targets: '.js-page-loader-logo',
		duration: 300,
		scale: "0.3",
		opacity: 0,
		easing: 'easeOutSine'
	})
	.add({
		targets: '.js-page-loader-curtain',
		duration: 500,
		translateY: "-100%",
		easing: 'easeInCubic'
	}, "-=300");

const beforeLeave = function (event, target) {
  if(target.getAttribute('target') && target.getAttribute('target') == "_blank") return;

  event.preventDefault();
  curtainOpenerTimeline.reverse();
  curtainOpenerTimeline.play();

  // setTimeout(() => {
    window.location.href = target.getAttribute("href");
  // }, 100)
}

curtainOpenerTimeline.play();

const menuItems = document.querySelectorAll('a');
menuItems.forEach(el => {
	const href = el.getAttribute('href')
	if(href && !href.includes('#')){
		el.addEventListener('click', (event) => {
			if (el.hasAttribute('data-fslightbox')) return; // crude workaround to prevent highjacking fslightbox functionality

			beforeLeave(event, el);
		})
	}
});
